import React from "react";
import styled from "styled-components";
import { StatusIndicator, DropDown, Text } from "@flexisaf/flexibull2";
import WAECLOGO from "../assets/waeclogo.png";
import Theme from "../theme";

const ExamCardContainer = styled.div`
  background: #fff;
  padding: 0.5rem 1rem;
  & .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    & .content-left {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      padding: 0.5rem 0;
      & img {
        border-radius: 50%;
        width: 50px;
        height: 50px;
      }
    }
    & .exam-title {
      p:first-of-type {
        font-size: 1rem;
      }
    }
  }
  & .card-body {
    display: flex;
    justify-content: center;
    padding: 2rem 0;
  }
  & .card-footer {
    display: flex;
    justify-content: center;
    gap: 2rem;
  }
`;

export const ExamCard = ({
  examData,
  examsCount,
  subjectCount,
  handleRedirect,
  handleEdit,
  handleDelete,
}) => {
  return (
    <ExamCardContainer>
      <div className="card-header">
        <div className="content-left">
          <img
            src={examData?.imageUrl ? examData?.imageUrl : WAECLOGO}
            alt="logo"
          />
          <div className="exam-title">
            <p>{examData?.name}</p>
          </div>
        </div>

        <DropDown
          label={
            <Text bold size="14px" style={{ cursor: "pointer" }}>
              ...
            </Text>
          }
          menuAlign="bottom right"
          trigger="click"
          menuList={[
            {
              onClick: () => handleEdit(),
              label: "Edit Group",
              iconLeft: "saf-receipt-edit",
            },
            {
              onClick: () => handleDelete(),
              label: "Delete Group",
              color: Theme.PrimaryRed,
              iconLeft: "saf-trash",
            },
          ]}
        />
      </div>
      <div style={{ cursor: "pointer" }} onClick={handleRedirect}>
        <div className="card-body">
          <StatusIndicator
            compound
            label={examData?.isActive ? "Active" : "Inactive"}
            color={examData?.isActive ? Theme.PrimaryGreen : Theme.PrimaryRed}
          />
        </div>

        <div className="card-footer">
          <p>
            {examData.examCount || 0} Exam{examData.examCount !== 1 && "s"}
          </p>
          <p>{`${subjectCount} Subjects`}</p>
        </div>
      </div>
    </ExamCardContainer>
  );
};
